import { ThemeOptions } from '../../../redux-store/channelTheme/channelTheme.interface'

const setDocumentProperty = (variable: string, value: string) => {
  document.documentElement.style.setProperty(variable, value)
}

const darken = (hex: string, percent: number): string => {
  const num = parseInt(hex.replace('#', ''), 16)
  const amt = Math.round(2.55 * percent)
  const R = (num >> 16) - amt
  const G = ((num >> 8) & 0x00FF) - amt
  const B = (num & 0x0000FF) - amt
  return `#${(
    0x1000000 +
    (Math.max(0, Math.min(R, 255)) << 16) +
    (Math.max(0, Math.min(G, 255)) << 8) +
    Math.max(0, Math.min(B, 255))
  )
    .toString(16)
    .slice(1)}`
}

const lighten = (hex: string, percent: number): string => {
  const num = parseInt(hex.replace('#', ''), 16)
  const amt = Math.round(2.55 * percent)
  const R = (num >> 16) + amt
  const G = ((num >> 8) & 0x00FF) + amt
  const B = (num & 0x0000FF) + amt
  return `#${(
    0x1000000 +
    (Math.max(0, Math.min(R, 255)) << 16) +
    (Math.max(0, Math.min(G, 255)) << 8) +
    Math.max(0, Math.min(B, 255))
  )
    .toString(16)
    .slice(1)}`
}

export const applyTheme = (theme: ThemeOptions) => {
  const primaryColor = theme.channelPrimaryColor

  //base colors frm BE
  setDocumentProperty('--channel-theme--primary-color', primaryColor)
  setDocumentProperty('--channel-theme--primary-background-color', theme.channelPrimaryBackgroundColor)
  setDocumentProperty('--channel-theme--primary-color-inverted', theme.channelPrimaryColorInverted)
  setDocumentProperty('--channel-theme--primary-background-color-inverted', theme.channelPrimaryBackgroundColorInverted)

  //fonts & extras
  setDocumentProperty('--channel-theme--text-transform', theme?.channelTextTransformation || 'none')

  if (theme.channelHeadingFontFamily) {
    setDocumentProperty('--channel-theme--heading-font-family', theme.channelHeadingFontFamily)
  }
  if (theme.channelHeadingFontWeight) {
    setDocumentProperty('--channel-theme--heading-font-weight', theme.channelHeadingFontWeight)
  }
  if (theme.channelSubmenuFontFamily) {
    setDocumentProperty('--channel-theme--submenu-font-family', theme.channelSubmenuFontFamily)
  }
  if (theme.channelSubmenuFontWeight) {
    setDocumentProperty('--channel-theme--submenu-font-weight', theme.channelSubmenuFontWeight)
  }
  if (theme.channelPrimaryHighlightColor) {
    setDocumentProperty('--channel-theme--primary-highlight-color', theme.channelPrimaryHighlightColor)
  }
  if (theme.channelCallToActionColor) {
    setDocumentProperty('--channel-theme--call-to-action-color', theme.channelCallToActionColor)
  }
  if (theme.channelCallToActionBackgroundColor) {
    setDocumentProperty('--channel-theme--call-to-action-background-color', theme.channelCallToActionBackgroundColor)
  }


  // === NEW ===

  //DERIVED COLORS (BUTTONS)
  setDocumentProperty('--channel-theme--primary-btn-background', primaryColor)
  setDocumentProperty('--channel-theme--primary-btn-text', '#ffffff')
  setDocumentProperty('--channel-theme--primary-btn-hover', darken(primaryColor, 10))
  setDocumentProperty('--channel-theme--primary-btn-disabled', lighten(primaryColor, 30))
  setDocumentProperty('--channel-theme--primary-btn-focus', darken(primaryColor, 20))

  // === END OF NEW ===
  
}
